import { ensureDatadogClient, isDatadogEnabled } from './datadogClient';

const isBrowser = typeof window !== 'undefined';

const ensureClientAvailable = () => {
  if (!isDatadogEnabled()) {
    return { rum: null, logs: null };
  }
  return ensureDatadogClient();
};

const getUserName = (user) => {
  const profile = user && user.attributes && user.attributes.profile ? user.attributes.profile : {};
  const firstName = profile.firstName || '';
  const lastName = profile.lastName || '';
  return `${firstName} ${lastName}`.trim() || undefined;
};

export const setUserContext = (user, segmentId = null) => {
  const { rum, logs } = ensureClientAvailable();
  if (!rum && !logs) {
    return;
  }

  const userId = user && user.id && user.id.uuid ? user.id.uuid : undefined;
  const email = user && user.attributes ? user.attributes.email : undefined;

  if (rum && typeof rum.setUser === 'function') {
    rum.setUser({ id: userId, email, name: getUserName(user), segmentId });
  }

  if (logs && typeof logs.addLoggerGlobalContext === 'function') {
    if (userId) {
      logs.addLoggerGlobalContext('user_id', userId);
    }
    if (email) {
      logs.addLoggerGlobalContext('user_email', email);
    }
    if (segmentId) {
      logs.addLoggerGlobalContext('segment_id', segmentId);
    }
  }
};

export const clearUserContext = () => {
  const { rum, logs } = ensureClientAvailable();
  if (rum && typeof rum.clearUser === 'function') {
    rum.clearUser();
  } else if (rum && typeof rum.removeUser === 'function') {
    rum.removeUser();
  }
  if (logs && typeof logs.clearUser === 'function') {
    logs.clearUser();
  }
  if (logs && typeof logs.removeLoggerGlobalContext === 'function') {
    logs.removeLoggerGlobalContext('user_id');
    logs.removeLoggerGlobalContext('user_email');
    logs.removeLoggerGlobalContext('segment_id');
  }
};

export const setGlobalContext = (context) => {
  if (!context || typeof context !== 'object') {
    return;
  }
  const { rum, logs } = ensureClientAvailable();
  Object.keys(context).forEach((key) => {
    if (rum && typeof rum.addRumGlobalContext === 'function') {
      rum.addRumGlobalContext(key, context[key]);
    }
    if (logs && typeof logs.addLoggerGlobalContext === 'function') {
      logs.addLoggerGlobalContext(key, context[key]);
    }
  });
};

export const trackPageView = (url, context = {}) => {
  const { rum } = ensureClientAvailable();
  if (!rum || typeof rum.startView !== 'function') {
    return;
  }

  const hasDocument = typeof document !== 'undefined';
  const name = context.name || (isBrowser && hasDocument ? document.title : url);
  rum.startView(name, {
    ...context,
    url,
  });
};

export const trackUserAction = (name, attributes = {}) => {
  const { rum } = ensureClientAvailable();
  if (!rum || typeof rum.addAction !== 'function') {
    return;
  }
  rum.addAction(name, {
    ...attributes,
  });
};
